/**
 * 设置权限
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *  * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024.09.23     2.0     Second version 根据 被设置人角度分配显示的权限 https://oss.essaone.com/24399216-a171-42b1-8913-8e0f1e49add6.jpg
 *
 */
import React from 'react';
import EssaModal from "@/components/EssaModal/EssaModal";
import HoverIcon from "@components/HoverIcon";
import { Spin, Checkbox, Tree, Popover,message } from 'antd';
import {postSaveOrUpdate, postUserMenus,} from "../../../../api/user";
import Lang from "@components/Lang/Lang";
import {isEmpty} from '@utils/utils';
import { toFixedWithCommas} from "@utils/number-util";
import {getRandomString} from "@utils/utils";
import SeparateSelect from "../SeparateSelect/SeparateSelect";
import "./index.less";
class AuthorityManage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            menuList:[],
            selectMenus:[],
            countryList:[], //可选 国家
            stickerTrackList:[],//可选 权限
            value:{

            }
        }
    }

    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    //菜单
    formatMenu(menuList=[],authOptionMap={}){
        let  selects = []
        menuList.forEach(item => {
            if(item.submenuList){
                const data = this.formatMenu(item.submenuList,authOptionMap)
                const isHasNum = data.menuList.filter(sub=>sub.isHas==1)||[];
                // if(isHasNum.length==)
                item.indeterminate = isHasNum.length>0 && isHasNum.length != data.menuList.length;
                // 后端可能只有一个菜单权限也返回 isHas =1,重置此状态
                if(isHasNum.length>0&&isHasNum.length == data.menuList.length){
                    item.isHas = 1;
                }else {
                    item.isHas = 0;
                }
                item.children = data.menuList;
                selects = [...selects, ...data.selects]
                authOptionMap= {...authOptionMap, ...data.authOptionMap}
            }else {
                if(item.buttonList){//最末级才有权限按钮
                    item.buttonList.forEach(btn=>{
                        // obj[btn.id] = btn.isHas == 1? true :false
                        // btn.id = "btn_"+btn.id
                        authOptionMap[btn.id] = btn.isHas == 1? true :false
                    })
                    // item.children = item.buttonList;
                }
            }
        })
        return {
            menuList:menuList,
            selects:selects,
            authOptionMap:authOptionMap
        }
    }
    getMenusList(useId) {
        this.loading(true)
        postUserMenus({
            id:useId
        }).then(res => {
            this.loading(false)
            const config = res.data.model || {};
            const {menuList,countryList,stickerTrackList,buyerLabelPermissionList=[],} = config;
            const data = this.formatMenu(menuList,{})||{};
            buyerLabelPermissionList.forEach(item=>item.value = item.categoryCode +"@" +item.code);
            this.setState({
                menuList: data.menuList,
                selectMenus: data.selects||[],
                // leafList:data.leafList||[],
                authOptionMap: data.authOptionMap||{},
                countryList:countryList||[], // 可以操作哪些国家的数据
                stickerTrackList:stickerTrackList||[],//参与哪些任务分配
                buyerLabelPermissionList:buyerLabelPermissionList,
                // positionCode:positionCode||""
            })
        })
    }
    /**
     * 打开权限菜单
     * */
    open() {
        this.openPermissionsModal(true);
        const { user } = this.props;
        this.getMenusList(user.id)
    }
    /**
     * 保存
     * */
    getCanPost(list=[],){
        let res=[]
        const { authOptionMap } = this.state;
        list.forEach(item=>{
            if(item.children&&item.children.length>0){
                const newRes = this.getCanPost(item.children);
                res = [...res,...newRes];
            }
            if(item.isHas){
                let obj = {
                    id: item.id
                }
                if(item.buttonList&&item.buttonList.length>0){
                    let buttonList = []
                    item.buttonList.forEach(btn=>{
                        if(authOptionMap[btn.id]) {
                            buttonList.push({
                                id: btn.id,
                                code: btn.code
                            })
                        }
                    })
                    obj["buttonList"] = buttonList;
                }
                res.push(obj)
            }
        })
        return res
    }
    async handlePermissionsOk() {
        const { menuList, value} = this.state;
        const { user } = this.props;
        // console.log("叶子",leafList)
        const postMenus = this.getCanPost(menuList);
        const data = {...value,
            id: user.id,
            menuList: postMenus
        }
        if(data.buyerLabelPermissionList&&data.buyerLabelPermissionList.length>0){
            let newPerList = [];
            data.buyerLabelPermissionList.forEach(sPer=>{
                const sList = sPer.split("@");
                console.log("sList",sList)
                newPerList.push({
                    categoryCode:sList[0],
                    code:sList[1],
                })
            })
            data.buyerLabelPermissionList = newPerList;
        }
        this.loading(true);
        postSaveOrUpdate(data).then(res=>{
            this.loading(false) ;
            const resData = res.data;
            const { success, valid,} = resData;
            if (success &&valid) {
                // 成功
                message.success(Lang({id:"CaoZuoChengGong"}))
                this.openPermissionsModal(false)
                if(this.props.callBack)this.props.callBack()
            }else if(resData.message){
                message.warning(resData.message)
            }else {
                message.warning(Lang({id:"BaoCunShiBai"}))
            }
        })

    }
    openPermissionsModal(flag=false) {
        if(flag){
            this.setState({
                permissionsVisible: true,
            })
        }else {
            this.setState({
                permissionsVisible: flag,
                menuList: [],
                selectMenus: [],
                // leafList: [],
                authOptionMap:{},
                countryList: [], // 可以操作哪些国家的数据
                stickerTrackList: [],//参与哪些任务分配
                buyerLabelPermissionList:[],
            })
        }
    }
    // 树操作
    renderNodeData(nodeData={},authOptionMap = {}){
        if(nodeData.level){
            let buttons = []
            if(nodeData.buttonList&&nodeData.buttonList.length>0) {
                {nodeData.buttonList.forEach(item => buttons.push(<Checkbox value={item.id}
                                                                        key={nodeData.id + "_" + item.id}
                                                                        // checked={item.isHas==1}
                                                                            checked={authOptionMap[item.id]}
                                                                        onChange={(e) => this.changeOption(item.id, authOptionMap[item.id])}>{item.name}</Checkbox>)
                )}
            }
            return (<div>
                <Checkbox value={nodeData.id}
                          key={nodeData.id}
                          indeterminate={nodeData.indeterminate}
                         checked={nodeData.isHas==1}
                         onChange={(e)=>this.checkMenu(nodeData.id,nodeData.isHas==1, nodeData.level, nodeData.parentId)}>
                <i className="ri-file-list-2-line mr_4"></i>{nodeData.name}
                    {buttons.length>0?<span className={"ml_60"}>{buttons}</span>:null}
                </Checkbox>
            </div>)
        }else return nodeData.name;
    }
    //选 中 权限 菜单
    checkMenu(id,isHas,level=0,parentId=""){
        let { menuList } = this.state;
        if(level>1&&parentId){ // 目前只到二级
           const parent = menuList.find(item => item.id == parentId);
            let iHasNum = 0
           if(parent.children){
               parent.children.forEach(chi=>{
                   if(chi.id==id){
                       chi.isHas = !isHas
                   }
                   if(chi.isHas) iHasNum += 1
               })
           }
            parent.indeterminate =  false
            parent.isHas =  false
           if(iHasNum>0){ // 响应一级
               if( iHasNum != parent.children.length){
                   parent.indeterminate =  true
               }
               if( iHasNum == parent.children.length){
                   parent.isHas =  true
               }
           }
        }else if(level==1){
            let current = menuList.find(item => item.id == id);
            current.indeterminate =  false
            current.isHas = !isHas
            if(current.children){
                current.children.forEach(chi=>{
                    chi.isHas = !isHas
                })
            }
        }
        this.setState({
            menuList:menuList
        })
    }
    changeOption(itemId,flag,){
        let {authOptionMap} = this.state;
        authOptionMap[itemId] = !flag
        this.setState({
            authOptionMap:authOptionMap,
        })
    }
    // 选择 下拉
    onChangeBack(sKey,data){
        const { value } = this.state;
        value[sKey] = data;
        this.setState({
            value:value
        })
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { user={} } = this.props;
        const {countryList=[], loading,permissionsVisible,menuList,authOptionMap, stickerTrackList=[],buyerLabelPermissionList=[] } = this.state;
        // 0 销售经理（国家），1 业务员（国家），2 客服（国家+客户），3 会计（国家）， 4 清关（国家+任务分配），5 仓管（国家），6 商品经理（国家），7 管理员（国家）
        const taskAssPermi =  user.positionCode=== "4";
        const cusPermi =  user.positionCode=== "2";
        return (<Spin tip='loading' spinning={loading}>
                <>
                    {/*权限修改*/}
                    <Popover content={Lang({id: 'QuanXianSheZhi'})}>
                        <div className="link" onClick={() => this.open()}>
                            <HoverIcon
                                inactiveIcon="icon-quanxian-1"
                                activeIcon="icon-quanxian-2"></HoverIcon>
                        </div>
                    </Popover>
                    {/*权限设置*/}
                    {permissionsVisible&&<EssaModal
                        width={600}
                        onOk={()=>this.handlePermissionsOk()}
                        onCancel={()=>this.openPermissionsModal()}
                        title={Lang({ id: "SheZhiQuanXian", default:'设置权限' })}
                        open={permissionsVisible}>
                        <p className={"black89 font_16 font-bold"}><i className="ri-user-line mr_6"></i>{user.name}</p>
                        <p className={"black100 mt_10"}>{Lang({id:"KeYiShiYongNaXieGongNeng",default:"可以使用哪些功能"})}</p>
                        <Spin spinning={loading}>
                        <div className={"authWrap mt_10"}>
                            <Tree
                                // defaultExpandParent={true}
                                defaultExpandAll={true}
                                selectable={false}
                                checkable = {false}
                                blockNode={false}
                                // checkStrictly={true}
                                // checkedKeys={selectMenus}
                                fieldNames={{
                                    title:"name",
                                    key:"id",
                                    // children:"submenuList"
                                }}
                                titleRender={(nodeData)=>this.renderNodeData(nodeData,authOptionMap)}
                                // onSelect={this.onTreeSelect}
                                // onCheck={this.onTreeCheck}
                                treeData={menuList}
                            />
                        </div>
                        {countryList.length>0?<SeparateSelect title={Lang({id:"KeYiCaoZuoNaXieGuoJiaDeShuJu",default:"可以操作哪些国家的数据"})}
                                                              onChangeBack={(res)=>this.onChangeBack("countryList",res)}
                                                              list={countryList} keyLabel={"countryName"} keyValue={"countryCode"}/>:null}
                        {taskAssPermi&&stickerTrackList.length>0?<SeparateSelect title={Lang({id:"CanYuNaXieRenWuFenPei",default:"参与哪些任务分配"})}
                                                                   onChangeBack={(res)=>this.onChangeBack("stickerTrackList",res)}
                                                                   placeholder={Lang({id:"SouSuoRenWu",default:"搜索任务"})}
                                                                   list={stickerTrackList} keyLabel={"salePoStickerTrackEvenName"} keyValue={"salePoStickerTrackEvenCode"}/>:null}
                        {cusPermi&&buyerLabelPermissionList.length>0?<SeparateSelect title={Lang({id:"FuZeNaXieKeHu",default:"负责哪些客户"})}
                                                                   onChangeBack={(res)=>this.onChangeBack("buyerLabelPermissionList",res)}
                                                                   placeholder={Lang({id:"FuZeNaXieKeHu",default:"负责哪些客户"})}
                                                                   list={buyerLabelPermissionList} keyLabel={"name"} keyValue={"value"} />:null}
                        </Spin>
                    </EssaModal>}
            </>
        </Spin>)
    }
}
export default AuthorityManage;
